export default function Loader({ label1, label2, logoSrc }) {
    return (
        <div className="loader-wrapper">
            <svg className="circle-text" viewBox="0 0 300 300">
                <defs>
                    <path
                        id="circle1"
                        d="M150,150 m-100,0 a100,100 0 1,1 200,0 a100,100 0 1,1 -200,0"
                    />
                    <path
                        id="circle2"
                        d="M150,150 m-130,0 a130,130 0 1,1 260,0 a130,130 0 1,1 -260,0"
                    />
                </defs>

                <text className="text-circle first">
                    <textPath
                        href="#circle1"
                        startOffset="0%"
                        textLength="610"
                        lengthAdjust="spacing"
                    >
                        {label1}
                    </textPath>
                </text>
                <text className="text-circle second">
                    <textPath
                        href="#circle2"
                        startOffset="0%"
                        textLength="800"
                        lengthAdjust="spacing"
                    >
                        {label2}
                    </textPath>
                </text>
            </svg>

            <div className="logo-container">
                <img src={logoSrc} alt="Loading Logo" />
            </div>
        </div>
    );
}
